import { render, staticRenderFns } from "./AtosAdministrativosPorEnteFederativoPorTipo.vue?vue&type=template&id=7253eba7&scoped=true"
import script from "./AtosAdministrativosPorEnteFederativoPorTipo.vue?vue&type=script&lang=js"
export * from "./AtosAdministrativosPorEnteFederativoPorTipo.vue?vue&type=script&lang=js"
import style0 from "./AtosAdministrativosPorEnteFederativoPorTipo.vue?vue&type=style&index=0&id=7253eba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253eba7",
  null
  
)

export default component.exports